import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomButton } from '../../../components/customButton/CustomButton';
import moment from 'moment';

export const ReporteBOTFilters = ({
    delegaciones = [],
    tiposReporte = [],
    filters,
    handleSearch,
    handleChangeFilters
}) => {

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{ marginBottom: '25px' }}
            >
                <Fragment>
                    <Grid size={{ xs: 12, md: 6, lg: 3, xl: 3 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Delegación',
                                name: 'idDelegacion',
                                options: delegaciones,
                                key: `${filters?.idDelegacion}-delegacion`
                            }}
                            value={filters.idDelegacion}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 2, xl: 2 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'select',
                                displayName: 'Tipo Reporte',
                                name: 'tipoReporte',
                                options: tiposReporte,
                                key: `${filters?.tipoReporte}-tipoReporte`
                            }}
                            value={filters.tipoReporte}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 6, lg: 2.5, xl: 2.5 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'date',
                                displayName: 'Fecha Desde',
                                name: 'fechaDesde',
                            }}
                            value={filters.fechaDesde}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 6, lg: 2.5, xl: 2.5 }}>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'date',
                                displayName: 'Fecha Hasta',
                                name: 'fechaHasta',
                            }}
                            value={filters.fechaHasta}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid sx={{ textAlign: 'right' }} size={{ xs: 6, sm: 6, lg: 2, xl: 2 }}>
                        <CustomButton
                            variant='contained'
                            onClick={() => handleSearch()}
                            size='small'
                            disabled={
                                !filters.tipoReporte ||
                                !filters.fechaDesde ||
                                !moment(filters.fechaDesde).isValid() ||
                                !filters.fechaHasta ||
                                !moment(filters.fechaHasta).isValid()
                            }
                        >
                            Buscar
                        </CustomButton>
                    </Grid>
                </Fragment>
            </Grid>
        </>
    )
}